/** Upload files, then add each one as a material with its own type and audience. */

import { Modal } from '@/ui/Modal';
import { AttachmentPicker } from '@/ui/Attachments';

import type { MaterialWriter } from './MaterialDialogs';
import { UploadedFileForm } from './UploadedFileForm';
import { useMaterialUploads } from './useMaterialUploads';

export function UploadDialog({ writer, onClose }: { writer: MaterialWriter; onClose: () => void }) {
  const { draft, landed, statusOf } = useMaterialUploads();
  return (
    <Modal
      title="Upload files"
      subtitle="Each file becomes a material once you choose its type and audience."
      size="wide"
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          {landed.length > 0 ? 'Close' : 'Cancel'}
        </button>
      }
    >
      <div className="stack-md">
        <AttachmentPicker draft={draft} id="material-files" label="Choose files" layout="table" />
        {landed.length > 0 && (
          <p className="hint">Files you do not add are removed after a day.</p>
        )}
        {landed.map(({ key, file }) => (
          <UploadedFileForm key={key} file={file} status={statusOf(file)} writer={writer} onAdded={() => draft.discard(key)} />
        ))}
      </div>
    </Modal>
  );
}
